import { InputfieldTypes } from "../../../enums/InputFieldAttributesEnums";

export const AddCustomerConsts = {
  ADD_MODAL_TITLE: "Add Customer",
  EDIT_MODAL_TITLE: "Edit Customer",
  FETCHING_DATA: "Fetching Data, Please wait...",
  MODAL_WIDTH: "50rem",
  CUSTOM_INPUT: "Custom Input",
  CASH: "Cash",
  CREATE_SUCCESS: "New Customer Profile Created Successfully",
  EDIT_SUCCESS: "Customer Profile Edited Successfull",
  EDIT_FAIL: "Some error occured while editing",
  CREATE_FAIL: "Some error occured while creating",
  ACCOUNT_LINK_FAIL: "Given link is not supported",
};

export const AccLinkModalConsts = {
  TITLE: "Account link confirmation",
  WIDTH: "50rem",
  CONTENT: "Are you sure you want to Override the account link?",
  STYLE_TOP: {
    top: "8.625rem",
  },
};

export const addCustomerFields = {
  CUSTOMER_NAME_NAME: "customerName",
  CUSTOMER_NAME_LABEL: "Customer Name",
  COMPANY_ADDRESS_NAME: "addressField",
  COMPANY_ADDRESS_LABEL: "Company Mailing Address",
  ADDRESS_DATA_NAME: "addressData",
  EMAIL_NAME: "emailAddress",
  EMAIL_LABEL: "Office Email",
  PHONE_NAME: "officePhone",
  PHONE_LABEL: "Office Phone",
  ACCOUNT_TERMS_NAME: "accountTerms",
  ACCOUNT_TERMS_LABEL: "Account Terms",
  CUSTOM_TERMS_NAME: "customTerms",
  CUSTOM_TERMS_LABEL: "Custom Terms",
  ACCOUNT_LINK_NAME: "accountLink",
  ACCOUNT_LINK_LABEL: "Account Link",
  NOTES_FIELD_NAME: "notesField",
  NOTES_FIELD_LABEL: "Notes",
};

export const getAddCustomerFields = ({
  onPhoneNumberChange,
  customTermsSelected,
  onLinkBlur,
  paymentOptions = [
    { label: "Cash", value: "Cash" },
    { label: "Custom Input", value: "Custom Input" },
  ],
}) => {
  return [
    {
      type: InputfieldTypes.TEXT,
      name: addCustomerFields.CUSTOMER_NAME_NAME,
      label: addCustomerFields.CUSTOMER_NAME_LABEL,
      visible: true,
      required: true,
      placeholder: "Enter customer name",
      span: 12,
    },
    {
      type: InputfieldTypes.GOOGLE,
      name: addCustomerFields.COMPANY_ADDRESS_NAME,
      label: addCustomerFields.COMPANY_ADDRESS_LABEL,
      visible: true,
      isFilterField: true,
      required: false,
      placeholder: "Search address",
      span: 12,
    },
    {
      type: InputfieldTypes.TEXT,
      name: addCustomerFields.EMAIL_NAME,
      label: addCustomerFields.EMAIL_LABEL,
      visible: true,
      placeholder: "Enter email address",
      span: 12,
    },
    {
      type: InputfieldTypes.ONCHANGE_TEXT,
      name: addCustomerFields.PHONE_NAME,
      label: addCustomerFields.PHONE_LABEL,
      visible: true,
      placeholder: "Enter phone number",
      onChange: onPhoneNumberChange,
      span: 12,
    },
    {
      type: InputfieldTypes.SELECT,
      name: addCustomerFields.ACCOUNT_TERMS_NAME,
      label: addCustomerFields.ACCOUNT_TERMS_LABEL,
      options: paymentOptions,
      visible: true,
      placeholder: "Select",
      span: 12,
      allowClear: true,
      showSearch: true,
    },
    {
      type: InputfieldTypes.TEXT,
      name: addCustomerFields.CUSTOM_TERMS_NAME,
      label: addCustomerFields.CUSTOM_TERMS_LABEL,
      visible: customTermsSelected,
      placeholder: "Enter terms",
      formattedNumberType: true,
      prefix: "Net ",
      large: true,
      span: 12,
    },
    {
      type: InputfieldTypes.TEXT,
      name: addCustomerFields.ACCOUNT_LINK_NAME,
      label: addCustomerFields.ACCOUNT_LINK_LABEL,
      visible: true,
      placeholder: "Enter link",
      onBlur: onLinkBlur,
      span: 12,
    },
    {
      type: InputfieldTypes.TEXT_AREA,
      name: addCustomerFields.NOTES_FIELD_NAME,
      label: addCustomerFields.NOTES_FIELD_LABEL,
      visible: true,
      placeholder: "Enter notes",
      maxLength: 500,
      textAreaRows: 4,
      noResize: true,
      span: 24,
    },
  ];
};
